import { createContext, useContext, useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, object=auth, false=not auth

  useEffect(() => {
    const token = localStorage.getItem("almar_token");
    if (!token) { setUser(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        const support = localStorage.getItem("almar_support_token");
        localStorage.removeItem("almar_support_token");
        if (support) { localStorage.setItem("almar_token", support); window.location.reload(); return; }
        localStorage.removeItem("almar_token"); setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("almar_token", data.token);
      setUser(data.user);
      return { ok: true };
    } catch (e) {
      return { ok: false, error: formatApiErrorDetail(e.response?.data?.detail) || e.message };
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("almar_token");
    localStorage.removeItem("almar_support_token");
    setUser(false);
  };

  const impersonating = !!localStorage.getItem("almar_support_token");

  const viewAs = async (targetId) => {
    const supportToken = localStorage.getItem("almar_support_token") || localStorage.getItem("almar_token");
    const { data } = await api.post("/auth/view-as", { target_user_id: targetId }, { headers: { Authorization: `Bearer ${supportToken}` } });
    localStorage.setItem("almar_support_token", supportToken);
    localStorage.setItem("almar_token", data.token);
    setUser(data.user);
  };

  const stopViewAs = async () => {
    const t = localStorage.getItem("almar_support_token");
    if (!t) return;
    localStorage.setItem("almar_token", t);
    localStorage.removeItem("almar_support_token");
    await refreshUser();
  };

  const refreshUser = async () => {
    const r = await api.get("/auth/me");
    setUser(r.data);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, logout, refreshUser, impersonating, viewAs, stopViewAs }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
